<div class="reservationSummary" *ngIf="hotelReservation"
  [class.reservationSummary--package-resume]="isPackageResume"
  [class.reservationSummary--package-booking]="isPackageBooking" 
  [class.reservationSummary--with-rooms]="showRoomsDetail"
  [class.reservationSummary--package-resume-step]="isPackageResumeStep">
  <div
    class="reservationSummary__item-container"
    [class.reservationSummary__item-container--package-resume]="isPackageResume"
    (click)="showHotelDetail.emit()">
    <div class="reservationSummary__info">
      <div class="reservationSummary__title">
        <span class="reservationSummary__hotel-name">{{hotelReservation.Hotel.HotelName}}</span>
        <a class="reservationSummary__show-more-chevron" (click)="showHotelDetail.emit()" *ngIf="showCompleteData">
          <app-ds-icon
            [icon]="icons.ChevronRight"
            [size]="16"
            [color]="iconFillColor.Secondary">
          </app-ds-icon>
        </a>
      </div>
      <div class="reservationSummary__hotel-package" [class.reservationSummary__hotel-package--package]="isPackageResumeStep">
        <div class="reservationSummary__hotel-classification">
          <div class="reservationSummary__stars">
            <ng-container *ngFor="let star of stars">
              <app-ds-icon
                [icon]="icons.Star"
                [size]="16"
                [color]="iconFillColor.Special">
              </app-ds-icon>
            </ng-container>
          </div>
          <span class="reservationSummary__destination" *ngIf="isByhours">{{destinationName$ | async | capitalize}}</span>
        </div>
        <ng-container *ngIf="isAdandonedReservation; else regularTemplate">
          <ng-container *ngTemplateOutlet="adandonedTemplate"></ng-container>
        </ng-container>
      </div>
      <div class="reservationSummary__room-info" *ngIf="hasRoomInfo">
        <ng-container *ngTemplateOutlet="basicRoomInfo"></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #basicRoomInfo>
  <ng-container *ngFor="let room of roomsDetail; trackBy: trackById">
    <p class="reservationSummary__room-info__text">{{room | capitalize}}</p>
  </ng-container>
</ng-template>

<ng-template #regularTemplate>
  <div class="hotelDatesInfo" [class.hotelDatesInfo--byhours]="isByhours">
    <ng-container *ngIf="!isByhours; else byHoursDateInfo">
      <ng-container *ngIf="showCompleteData; else packageNightsCounter">
        <p class="hotelDatesInfo__dates">{{ checkIn }} - {{ checkOut }}</p>
      </ng-container>
      <div class="hotelDatesInfo__rooms-info">
        <div class="hotelDatesInfo__item">
          <app-ds-icon
            [icon]="icons.Bed"
            [size]="16"
            [color]="iconFillColor.Secondary">
          </app-ds-icon>
          <p>{{rooms}}</p>
        </div>
        <div class="hotelDatesInfo__item">
          <app-ds-icon
            [icon]="icons.PersonOutline"
            [size]="16"
            [color]="iconFillColor.Secondary">
          </app-ds-icon>
          <p>{{ guest }}</p>
        </div>
        <span class="hotelDatesInfo__separator">●</span>
        <span>{{destinationName$ | async | capitalize}}</span>
      </div>
    </ng-container>
    <ng-template #byHoursDateInfo>
      <div class="hotelDatesInfo__rooms-info hotelDatesInfo__rooms-info--byhours">
        <div class="hotelDatesInfo__item">
          <app-ds-icon
            [icon]="icons.Calendar"
            [size]="16"
            [color]="iconFillColor.Secondary">
          </app-ds-icon>
          <p class="dates">{{ checkIn }}</p>
        </div>
        <div class="hotelDatesInfo__item">
          <app-ds-icon
            [icon]="icons.Clock"
            [size]="16"
            [color]="iconFillColor.Secondary">
          </app-ds-icon>
          <p>{{ checkInHour }}</p>
        </div>
        <div class="hotelDatesInfo__item">
          <app-ds-icon
            [icon]="icons.DepartureDuration"
            [size]="16"
            [color]="iconFillColor.Secondary">
          </app-ds-icon>
          <p>{{'HOTELS_MODULE.DETAIL_DESCRIPTION.ABBREVIATION_HOURS'| transloco: { hours: packHour } }}</p>
        </div>
        <div class="hotelDatesInfo__item">
          <app-ds-icon
            [icon]="icons.Bed"
            [size]="16"
            [color]="iconFillColor.Secondary">
          </app-ds-icon>
          <p>{{rooms}}</p>
        </div>
        <div class="hotelDatesInfo__item">
          <app-ds-icon
            [icon]="icons.PersonOutline"
            [size]="16"
            [color]="iconFillColor.Secondary">
          </app-ds-icon>
          <p>{{ guest }}</p>
        </div>
      </div>
    </ng-template>
  </div>  
</ng-template>

<ng-template #adandonedTemplate>
  <div class="hotelDatesInfo">
    <p class="hotelDatesInfo__dates">{{ checkIn }} - {{ checkOut }}</p>
    <div class="hotelDatesInfo__rooms-info">
      <span class="hotelDatesInfo__separator">●</span>
      <ng-container *ngIf="isAdandonedPackageReservation; else hotelAbandoned">
        <ng-container *ngTemplateOutlet="packageNightsCounter"></ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #hotelAbandoned>
  <ng-container *ngIf="isByhours; else hotelNightsCounter">
    <ng-container *ngTemplateOutlet="hotelHoursCounter"></ng-container>
  </ng-container>
</ng-template>

<ng-template #hotelHoursCounter>
    <p class="hotelDatesInfo__hours-counter">{{'HOTELS_MODULE.DETAIL_DESCRIPTION.ABBREVIATION_HOURS'| transloco: { hours: packHour } }}</p>
</ng-template>

<ng-template #hotelNightsCounter>
  <ng-container *ngIf="isOneNight; else multipleNights">
    <p class="hotelDatesInfo__nights-counter">{{nights}} {{'HOTELS_MODULE.RESULT_HOTELS.NIGHT' | transloco }}</p>
  </ng-container>
  <ng-template #multipleNights>
    <p class="hotelDatesInfo__nights-counter">{{nights}} {{'HOTELS_MODULE.RESULT_HOTELS.NIGHTS' | transloco }}</p>
  </ng-template>
</ng-template>

<ng-template #packageNightsCounter>
  <ng-container *ngIf="isOneNight; else multipleNights">
    <p class="hotelDatesInfo__nights-counter">{{'PACKAGES_MODULES.PACKAGES_RESUME_DETAIL.ONE_NIGHT' | transloco}}</p>
  </ng-container>
  <ng-template #multipleNights>
    <p class="hotelDatesInfo__nights-counter">{{'PACKAGES_MODULES.PACKAGES_RESUME_DETAIL.MULTIPLE_NIGHTS' | transloco : { quantity: nights } }}</p>
  </ng-template>
</ng-template>
